import { useEffect, useState } from "react";
import api from "../../lib/api";
import DashboardLayout from "../../components/layout/DashboardLayout";
import { formatDateTime } from "../../lib/format";

export default function AdminDownloads() {
    const [logs, setLogs] = useState([]);

    useEffect(() => { api.get("/admin/downloads").then(({ data }) => setLogs(data || [])); }, []);

    return (
        <DashboardLayout role="admin">
            <div className="mb-8" data-testid="admin-downloads-page">
                <div className="label-mono mb-3">/ Download history</div>
                <h1 className="font-heading font-black text-3xl lg:text-4xl tracking-tighter">Descargas</h1>
            </div>
            <div className="panel overflow-x-auto">
                <table className="w-full text-sm min-w-[900px]">
                    <thead className="bg-avx-surface/80 border-b border-avx-line">
                        <tr className="label-mono text-left">
                            <th className="px-4 py-3 font-normal">Client</th>
                            <th className="px-4 py-3 font-normal">Product</th>
                            <th className="px-4 py-3 font-normal">System</th>
                            <th className="px-4 py-3 font-normal">Version</th>
                            <th className="px-4 py-3 font-normal">File</th>
                            <th className="px-4 py-3 font-normal">IP</th>
                            <th className="px-4 py-3 font-normal">Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {logs.map((l) => (
                            <tr key={l.id} className="border-b border-avx-line/60 hover:bg-avx-surface/40" data-testid={`dl-row-${l.id}`}>
                                <td className="px-4 py-3">
                                    <div>{l.user?.name}</div>
                                    <div className="font-mono text-[10px] text-avx-muted">{l.user?.email}</div>
                                </td>
                                <td className="px-4 py-3">{l.product_name}</td>
                                <td className="px-4 py-3 font-mono">{l.os}</td>
                                <td className="px-4 py-3 font-mono">{l.version}</td>
                                <td className="px-4 py-3 font-mono text-xs truncate max-w-[180px]">{l.file_name || "—"}</td>
                                <td className="px-4 py-3 font-mono text-xs">{l.ip_address}</td>
                                <td className="px-4 py-3 font-mono text-xs">{formatDateTime(l.downloaded_at)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {logs.length === 0 && <div className="p-8 text-center text-avx-muted text-sm">No downloads recorded yet.</div>}
            </div>
        </DashboardLayout>
    );
}
